<div class="modal fade modal--mini" id="claim-initiated-guard-modal" tabindex="-1" role="dialog" aria-labelledby="claim-initiated-guard-modal-title" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-mini">

      <div class="modal-mini__heading">
        <div class="container-fluid">
          <h4 id="claim-initiated-guard-modal-title">{{ header }}</h4>
        </div>
      </div>

      <div class="modal-mini__content">
        <div class="container-fluid">
          <div class="rte">
            <p>{{ body }}</p>
          </div>
        </div>
      </div>

      <div class="modal-mini__button">
        <div class="container-fluid">
          <a href="javascript:void(0);" class="button button--secondary" (click)="onCancel()">Cancel</a>
          <a href="javascript:void(0);" class="button button--primary" (click)="onContinue()">Continue</a>
        </div>
      </div>

    </div>
  </div>
</div>
